import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.css";

const LoadingSpinner = (props) => {
  const { size = 40 } = props;

  return (
    <div
      className="spinner"
      style={{ width: size + "px", height: size + "px" }}
    >
      <CircularProgress disableShrink color="secondary" value={60} {...props} />
    </div>
  );
};

export default LoadingSpinner;
